<template>
  <div class="statistics">
    <ul>
      <li>
        <p>总收益金额</p>
        <p>{{ statistics.money_total ? statistics.money_total : "0" }}</p>
      </li>
      <li>
        <p>团队人数</p>
        <p>
          {{ statistics.my_group ? statistics.my_group : "0" }}<span>人</span>
        </p>
      </li>
      <li>
        <p>团队销售数量</p>
        <p>
          {{ statistics.my_group_order ? statistics.my_group_order : "0"
          }}<span>个</span>
        </p>
      </li>
      <li>
        <p>直推销售数量</p>
        <p>
          {{ statistics.my_user_order ? statistics.my_user_order : "0"
          }}<span>个</span>
        </p>
      </li>
      <li>
        <p>直推购买人数</p>
        <p>
          {{ statistics.my_user ? statistics.my_user : "0" }}<span>人</span>
        </p>
      </li>
      <li>
        <p>自购数量</p>
        <p>
          {{ statistics.my_order ? statistics.my_order : "0" }}<span>个</span>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import { getstatistics } from "../../api/home";
export default {
  data() {
    return {
      statistics: {},
    };
  },
  created() {
    getstatistics()
      .then((res) => {
        this.statistics = res.data.backdata;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style lang='scss'>
.statistics {
  width: 100%;
  height: 100%;
  background: #f3f1f4;
  padding-top: 0.6rem;
  ul {
    width: 100%;
    background: #ffffff;
    padding-left: 0.15rem;
    li {
      width: 100%;
      height: 0.58rem;
      border-bottom: 0.01rem solid #f3f1f4;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 0.15rem;

      font-size: 0.14rem;
      color: #333333;
      :nth-child(2) {
        font-size: 0.16rem;
        color: #ff5d5d;
        span {
          color: #333333;
        }
      }
    }
  }
}
</style>